<template>
<div :id="'homecare-topic-table-area-'+tableName" class="homecare-topic-table-area">
  <div class="page print-info-area fs13 p20 mb-4">
    <PDFHeader :title="$t('home_care_notebook')"/>
    <div class="bodyPDF">
      <div :id="'detail-content-area-'+tableName" class="detail-content-area float-left">
        <p class="title-table">{{tableTitle}}</p>
        <div class="list-time-area">
          <ul>
            <li class="pl-3 pr-3">更新日：{{dataTabFormatted.date}}</li>
          </ul>
        </div>
        <div :class="['home-care-table', tableName]">
          <table>
            <tr v-for="(row, rowIndex) in listColumnTable" :key="tableName+rowIndex">
              <template v-for="(value, name, rowDataIndex) in row">
                <td :key="tableName+'-'+rowIndex+'-'+rowDataIndex+'-0'">{{value}}</td>
                <td
                  :colspan="Object.keys(row).length == 1 ? 3 : 1"
                  :key="tableName+'-'+rowIndex+'-'+rowDataIndex+'-1'"
                >
                  {{
                    (dataTabFormatted[name] || dataTabFormatted[name] == 0 ) ?
                    ((name === 'start_time' || name === 'end_time') ? dataTabFormatted[name] + '時' : (value.includes('插入長(mm)') ? convertCalculateUnit(dataTabFormatted[name], '*') : (value.includes('吸引深さ制限(cm)') ? convertCalculateUnit(dataTabFormatted[name], '/') : dataTabFormatted[name])) ) : 
                    'ー'
                  }}
                </td>
              </template>
            </tr>
          </table>
          <div v-show="isShowImage" class="table-image-area">
            <div class="title-list-image border-top-0">画像</div>
            <div v-if="dataTabFormatted['attach_images_'+tableName] == null" class="list-image">
              <p>画像のデータがありません</p>
            </div>
            <div v-else class="list-image" :style="{height: heightImageArea+'px'}">
              <template v-for="(img_url, index) in dataTabFormatted['attach_images_'+tableName]">
                <img
                  v-if="index < 2"
                  :key="tableName+'_img_'+index"
                  :src="img_url"
                  :style="[dataTabFormatted['attach_images_'+tableName].length == 1 ? {maxWidth: '100%'} : '']"
                />
              </template>
            </div>
          </div>
        </div>
        <hr v-if="listImageStillNotShow.length == 0"  class="float-left w-100">
      </div>
    </div>
  </div>
  <!-- SPLIT NEW PAGE WHEN HAVE MANY IMAGE -->
  <template v-for="(listImage, index) in listImageStillNotShow">
    <HomeCareImagePage
      :key="index"
      :tableName="tableName"
      :listImage="listImage"
      :isShowEndline="index == listImageStillNotShow.length - 1"
    />
  </template>
</div>
</template>
<script>
const HEIGHT_OF_SPACE_AREA_FIRST_PAGE = 855 // height of paper - padding top bottom - header - title - first row - end line = 1123 - 40 - 110 - 36 - 40 - 42
const MIN_HEIGHT_IMAGE_AREA = 560
const HEIGHT_OF_IMAGE_EMPTY_ROW = 80
import PDFHeader from '../PDFHeader.vue'
import HomeCareImagePage from './HomeCareImagePage.vue'
export default {
  components: {
    PDFHeader,
    HomeCareImagePage,
  },
  props: [
    'tableName',
    'tableTitle',
    'listColumnTable',
    'dataTabFormatted',
  ],
  data() {
    return {
      listImageStillNotShow: [],
      heightImageArea: 40,
      isShowImage: true,
      listImageSplit: null
    }
  },
  async mounted() {
    let tableEl = document.getElementsByClassName(this.tableName)[0]
    if(tableEl) {
      this.heightImageArea = HEIGHT_OF_SPACE_AREA_FIRST_PAGE - Math.floor(tableEl.offsetHeight - HEIGHT_OF_IMAGE_EMPTY_ROW)
      this.isShowImage = this.heightImageArea >= MIN_HEIGHT_IMAGE_AREA || this.dataTabFormatted['attach_images_' + this.tableName] == null
    }
    else {
      this.heightImageArea = 0
    }
    let numberImageShow = this.isShowImage ? 2 : 0
    if(this.dataTabFormatted['attach_images_' + this.tableName] && this.dataTabFormatted['attach_images_' + this.tableName].length > numberImageShow) {
      let chuck = 2
      this.listImageStillNotShow = []

      for (let i= numberImageShow; i < this.dataTabFormatted['attach_images_' + this.tableName].length; i += chuck) {
        this.listImageStillNotShow.push(this.dataTabFormatted['attach_images_' + this.tableName].slice(i, i + chuck))
      }
    }
  },
  methods: {
    convertCalculateUnit(value, flg) {
      if (flg == '*') {
        return parseFloat((value * 10).toFixed(13))
      } else {
        return parseFloat((value / 10).toFixed(13))
      }
    },
  }
}
</script>
